import { AuthProvider } from '@pata-app/ui-auth';

import { ResourcesConfig } from 'aws-amplify';
import React from 'react';
// import { hydrate } from 'react-dom';
import ReactDOMClient from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import 'vanilla-cookieconsent/dist/cookieconsent.css';

// import { worker } from '../mocks/browser';
// import mockData from '../mocks/mockData/mock-business-details.json';
import App from './app/app';
import { CallToBookProvider } from './contexts/call-to-book.context';
import './i18n';
import './sentry/instrument';

// const dehydratedState = window.__REACT_QUERY_STATE__;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // staleTime: 30000,
    },
  },
});
const container = document.getElementById('root');

if (process.env.NODE_ENV === 'development') {
  // window._searchData = {
  //   searchTerm: 'veterinarian',
  //   searchTermType: 'category',
  //   lat: '53.10040499999999',
  //   lng: '-2.4438209',
  //   location: 'crewe',
  // };
  // worker.start();
}

const root = ReactDOMClient.createRoot(container);

const hostname = new URL(window.location.href).origin;

const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.AWS_COGNITO_USER_POOL_ID || '',
      userPoolClientId: process.env.AWS_COGNITO_USER_POOL_WEB_CLIENT_ID || '',
      identityPoolId: process.env.AWS_COGNITO_IDENTITY_POOL_ID || '',
      loginWith: {
        oauth: {
          domain: process.env.AWS_COGNITO_DOMAIN || '',
          scopes: ['email', 'profile', 'openid'],
          redirectSignIn: [`${hostname}`],
          redirectSignOut: [`${hostname}`],
          responseType: 'code',
        },
        username: true,
      },
    },
  },
};

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthProvider baseMainApiUrl={process.env.API_USER_ROOT_URL} amplifyConfig={amplifyConfig}>
        <CallToBookProvider>
          <App />
        </CallToBookProvider>
      </AuthProvider>
    </BrowserRouter>
  </QueryClientProvider>,
);
